// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_AgentSettingsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * AiCredits_AgentSettingsInput — body for POST /ai/agent-settings.
 *
 * The field is optional; omitting it leaves the setting unchanged.
 *
 * Optional:
 *   ai_max_context (int|null) — max conversation-history message count for the AI agent
 */
import { registerContract } from './validate'

export interface AiCredits_AgentSettingsInput {
ai_max_context?: number
}

registerContract('AiCredits_AgentSettingsInput', {
  ai_max_context: { type: 'number',  required: false },
})
